import { useCallback } from 'react'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { ITEditableTextProps, ITEditableText, ITEditableNameProps, ITEditableName } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITRectangularInputSmallProps, ITRectangularInputSmall, ITInputNumericProps, ITInputNumeric, ITInputQuantityProps, ITInputQuantity, ITInputQuantity2, ITInputCalendarProps, ITInputCalendar, ITInputDiscountProps, ITInputDiscount, ITInputPriceProps, ITInputPrice, ITSelectSpecificPriceRuleProps, ITSelectSpecificPriceRule, ITInputPercentage, ITInputPercentageProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { ITInputsOnChangeInputs } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { checkIfSerialNumberAndIsProcessed } from '../../../../../../../utils/globals/product/uniqueNumber'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import useOrderProcessedTypesDict, { ProcessedTypeDict } from '../../../../../../../utils/hooks/orders/useOrderProcessedTypesDict'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { faXmarkCircle } from '@fortawesome/pro-light-svg-icons'


export const OrderRectangularInputSmall: React.FC<ITRectangularInputSmallProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITRectangularInputSmall readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderInputNumeric: React.FC<ITInputNumericProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return <ITInputNumeric {...all} readOnlyFnc={readOnlyFnc} />
}

export const OrderInputQuantity: React.FC<ITInputQuantityProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => {
        return (!allRowData.ProductId || allRowData.processed || checkIfSerialNumberAndIsProcessed(allRowData))
    }
    return (
        <ITInputQuantity readOnlyFnc={readOnlyFnc} {...all} />
    )
}
export const OrderInputQuantity2: React.FC<ITInputQuantityProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => {
        return(!allRowData.ProductId || allRowData.processed || checkIfSerialNumberAndIsProcessed(allRowData))
    }
    return (
        <ITInputQuantity2  readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderInputQuantityProductType: React.FC<ITInputQuantityProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => {
        return (!allRowData.ProductTypeId || allRowData.processed)
    }
    return (
        <ITInputQuantity readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderInputCalendar: React.FC<ITInputCalendarProps> = ({...all}) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITInputCalendar readOnlyFnc={readOnlyFnc} {...all} />
    )
}


export const OrderInputDiscount: React.FC<ITInputDiscountProps> = ({...all}) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITInputDiscount readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderInputPrice: React.FC<ITInputPriceProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITInputPrice readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderInputPercentage: React.FC<ITInputPercentageProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITInputPercentage readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderEditableText: React.FC<ITEditableTextProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITEditableText readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderEditableTextProductType: React.FC<ITEditableTextProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductTypeId || allRowData.processed
    return (
        <ITEditableText readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderEditableName: React.FC<ITEditableNameProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITEditableName readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export const OrderCustomSelectBlockedItemsSearchbar: React.FC<ITSelectSpecificPriceRuleProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => {
        return !permissionCheck(getUserPermissions('quoteOther.updateQuoteSpecificPrice'), 'read') || (!allRowData.ProductId || allRowData.processed || checkIfSerialNumberAndIsProcessed(allRowData))
    }
    return (
        <ITSelectSpecificPriceRule readOnlyFnc={readOnlyFnc} {...all} />
    )
}

export interface ITCustomSelectProps {
    items: TwinDictionary
    value?: number
}

export interface OrderSaveRemainingProductProps {
    value: boolean
    readOnlyFnc?: (allRowData: RowData) => boolean
    forceNullBoolean?: boolean
    allRowData: RowData
    onChange: ITInputsOnChangeInputs
    dataKey: string
}

export const OrderSaveRemainingProduct: React.FC<OrderSaveRemainingProductProps> = ({ allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const processedTypesDict = useOrderProcessedTypesDict()
    if (allRowData.processed) {
        const myValue = processedTypesDict[allRowData.processed]
        return (
            <div className={'flex items-center justify-center text-center ' + (myValue?.colorText || '')}>
                <TwinIcon className='mr-5' icon={myValue.icon} />
                <span>
                    {myValue?.title}
                </span>
            </div>
        )
    }
    return (
        <ITOrderBooleanRectangle allRowData={allRowData} {...rest} translations={{
            positive: t('save', 'Guardar'),
            negative: t('notSave', 'No guardar')
        }} />
    )
}
export interface OrderRefundProductProps {
    value: boolean
}

export const OrderRefundProduct: React.FC<OrderRefundProductProps> = ({ value }) => {
    if (value) {
        return (
            <div className={'flex items-center justify-center text-center text-red-BA'}>
                <TwinIcon className='mr-5' icon={faXmarkCircle} />
                <span>
                    <TwinTrans transKey={'refunded'}>Devuelto</TwinTrans>
                </span>
            </div>
        )
    }
    return null
}

export interface ITOrderBooleanRectangleProps extends ITOrderBooleanRectangleLogicProps {
    value: boolean
    forceNullBoolean?: boolean
    readOnlyFnc?: (allRowData: RowData) => boolean
    translations: {
        positive: string
        negative: string
    }
}

export const ITOrderBooleanRectangle: React.FC<ITOrderBooleanRectangleProps> = ({ value, allRowData, forceNullBoolean, readOnlyFnc, translations, ...logic }) => {
    const { myOnChange } = useITOrderBooleanRectangleLogic({ allRowData, ...logic })
    const nullFnc = (allRowData: any) => forceNullBoolean || !allRowData.ProductId || parseInt(allRowData.processed)
    if (nullFnc(allRowData)) {
        return null
    }

    const readOnly = readOnlyFnc?.(allRowData) || false
    const dictValues: { [id: string]: ProcessedTypeDict } = {
        'true': { title: translations.positive, colorText: 'text-green-43' },
        'false': { title: translations.negative, colorText: 'text-red-BA' }
    }
    const myValue = dictValues[String(value)]
    return (
        <div className={'flex items-center justify-center border rounded-5 px-10 py-1 text-center cursor-pointer w-full ' + (myValue?.colorText || '')} onClick={() => !readOnly ? myOnChange(!value) : {}}>
            {myValue?.title}
        </div>
    )
}

interface ITOrderBooleanRectangleLogicProps {
    allRowData: RowData
    onChange: ITInputsOnChangeInputs
    dataKey: string
}

const useITOrderBooleanRectangleLogic = ({ onChange, allRowData, dataKey }: ITOrderBooleanRectangleLogicProps) => {
    const myOnChange = useCallback((value: any) => {
        onChange(allRowData.absoluteIndex || allRowData.rowIndex, dataKey, value)
    }, [onChange, dataKey, allRowData.absoluteIndex, allRowData.rowIndex])

    return { myOnChange }
}